var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#f44336",
      fillOpacity: 0.997905,
      strokeWidth: 1.13386,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2 373.336C20.07 216.58 0 200.493 0 142.884 0 63.97 63.971 0 142.884 0c78.912 0 142.883 63.971 142.883 142.884 0 57.61-20.07 73.697-128.199 230.452-7.096 10.25-22.273 10.25-29.369 0zm14.684-170.917c32.88 0 59.535-26.655 59.535-59.535 0-32.88-26.655-59.535-59.535-59.535-32.88 0-59.535 26.654-59.535 59.535 0 32.88 26.654 59.535 59.535 59.535z",
    style: {
      fill: "#fff",
      strokeWidth: 0.744186
    },
    transform: "translate(25.666 14.43) scale(.94363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.618 138.664c-108.129 156.755-128.2 172.843-128.2 230.452C202.419 448.03 266.39 512 345.303 512c78.913 0 142.884-63.971 142.884-142.884 0-57.61-20.07-73.697-128.2-230.452-7.095-10.25-22.273-10.25-29.368 0zm14.684 170.917c32.88 0 59.535 26.655 59.535 59.535 0 32.88-26.654 59.535-59.535 59.535-32.88 0-59.535-26.654-59.535-59.535 0-32.88 26.655-59.535 59.535-59.535z",
    style: {
      strokeWidth: 0.744186
    },
    transform: "translate(25.666 14.43) scale(.94363)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      strokeWidth: 0.702238
    },
    d: "M351.504 306.56c31.027 0 56.18 25.153 56.18 56.18s-25.153 56.18-56.18 56.18-56.178-25.153-56.178-56.18 25.15-56.18 56.178-56.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      strokeWidth: 0.702238
    },
    d: "M160.496 93.08c31.027 0 56.178 25.153 56.178 56.18s-25.15 56.18-56.178 56.18c-31.027 0-56.18-25.153-56.18-56.18s25.153-56.18 56.18-56.18z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.deadcb6d15579ba31d035d463e5f4422.svg";
export { ForwardRef as ReactComponent };